<div style="padding:60px">
    <p *ngIf="status=='NOK'" class="alert alert-danger">پرداخت با موفقیت انجام نشد</p>
    <p *ngIf="status=='OK'" class="alert alert-warning">پرداخت با موفقیت انجام شد. در حال ثبت حساب کاربری ...</p>
    <p *ngIf="status=='OK-REGISTERED'" class="alert alert-success">پرداخت با موفقیت انجام شد. حساب کاربری با موفقیت
        ایجاد شد.<a routerLink="/account/login">ورود به حساب کاربری</a></p>
</div>